<template>
  <div id="app__ernest">
    <header class="app__header__ernest">
      <div>
        <u-icon>Ù</u-icon>
      </div>
      <div>
        <div><span>{{ $t('app.ernestHeader.questionnaireList') }}</span></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div></div>
    </header>

    <section class="app__section__ernest">
      <v-card>
        <v-card-title>
          {{ $t('pages.questionnaires.list.title.name') }}
          <v-spacer/>
          <v-text-field
            v-model="search"
            append-icon="search"
            :label="$t('components.searchPlaceholder')"
            single-line
            hide-details
          />
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="questionnaires"
          :search="search"
        >
          <template v-slot:item.actions="{ item }">
            <div class="table__actions__buttons">
              <router-link :to="{ name: 'questionnairePublication', params: {id: item.id}}"
                           :title="$t('pages.questionnaires.list.tooltip.options')"
              >
                <div class="icon__google">
                  <u-icon>á</u-icon>
                </div>
              </router-link>

              <router-link :to="{ name: 'questionnaireDuplication', params: {id: item.id}}"
                           :title="$t('pages.questionnaires.list.tooltip.duplicate')"
              >
                <div>
                  <u-icon>Ù</u-icon>
                </div>
              </router-link>

              <span v-if="!isPublished(item)">
                <div @click.stop="onActiveDialog(item)" class="icon__google">
                  <v-icon :title="$t('pages.questionnaires.list.tooltip.delete')">mdi-delete-outline</v-icon>
                </div>
              </span>
            </div>
          </template>

          <template #item.label="{ item }">
            <router-link :to="{ name: 'questionnaireCreation', params: {id: item.id }}"
                         v-if="isSelectedRepository(item.repository)">
              {{ item.label }}
            </router-link>
            <span v-else class="text--disabled">
              {{ item.label }}
              <br/>{{ getRepositoryLabel(item.repository) }}
            </span>
          </template>

          <template #item.publicationDate="{ item }">
            <v-icon v-if="!isPublished(item)" color="red">mdi-close</v-icon>
            <v-icon v-else color="green">mdi-check</v-icon>
            &nbsp;
            <span>{{ getLocalePublishedDate(item.publicationDate) }}</span>
          </template>

          <template v-slot:no-data>
            {{ $t('pages.questionnaires.list.noData.name') }}
          </template>

          <template v-slot:no-results>
            {{ $t('pages.questionnaires.list.noResult.name') }}
          </template>
        </v-data-table>
      </v-card>
    </section>

    <v-dialog v-model="deleteDialog.display"
              width="500"
              id="delete__dialog"
    >

      <v-card>
        <v-card-title class="font-weight-black">
          {{ deleteDialog.text }}
        </v-card-title>
        <v-card-actions>
          <v-btn color="valid" @click.stop="onDelete">
            {{ $t('components.buttons.delete') }}
          </v-btn>
          <v-btn color="cancel" @click.stop="onCancelDelete">
            {{ $t('components.buttons.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'questionnairesList',
  data () {
    return {
      deleteDialog: {
        display: false,
        text: this.$t('pages.questionnaires.list.dialogText')
      },
      headers: [
        {
          text: this.$t('pages.questionnaires.list.headers.label'),
          value: 'label'
        },
        {
          text: this.$t('pages.questionnaires.list.headers.pageNumber'),
          value: 'pageNumber'
        },
        {
          text: this.$t('pages.questionnaires.list.headers.publication'),
          value: 'publicationDate'
        },
        {
          text: '',
          value: 'actions',
          sortable: false
        }
      ],
      itemsSelectedToDelete: null,
      search: '',
      tooltip1: false
    }
  },
  computed: {
    ...mapGetters('Questionnaires', [
      'questionnaires'
    ]),
    ...mapGetters('Repositories', ['repositorySelectedId', 'repositories'])
  },
  async created () {
    await this.loadQuestionnaires()
  },
  methods: {
    ...mapActions('Questionnaires', [
      'questionnaireDeletion',
      'loadQuestionnaires'
    ]),
    getLocalePublishedDate (publicationDate) {
      return publicationDate
        ? new Date(publicationDate).toLocaleString(navigator.language)
        : ''
    },
    /**
     * @param {QuestionnaireAir} questionnaire
     * @return {Boolean}
     */
    isPublished (questionnaire) {
      return questionnaire.isPublished &&
        questionnaire.publicationTime !== null &&
        questionnaire.publicationDate !== null
    },
    onActiveDialog (questionnaire) {
      this.itemsSelectedToDelete = questionnaire
      this.deleteDialog.display = true
    },
    onCancelDelete () {
      this.itemsSelectedToDelete = null
      this.deleteDialog.display = false
    },
    onDelete () {
      this.questionnaireDeletion(this.itemsSelectedToDelete)
      this.deleteDialog.display = false
    },
    isSelectedRepository (itemRepositoryId) {
      return this.repositorySelectedId === itemRepositoryId
    },
    getRepositoryLabel (itemRepositoryId) {
      const { name } = this.repositories.find(repository => repository.id === itemRepositoryId)
      return this.$t('pages.questionnaires.list.repositoryInfo', { name })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/style/styleAppErnest";
  @import "../../assets/style/styleAppTableListErnest";
  @import "../../assets/style/styleAppTooltipErnest";

  div {
    #delete__dialog {
      .v-card__actions {
        display: flex;
        justify-content: flex-end;
      }
    }

    span {
      .icon__google {
        i {
          cursor: pointer;
        }
      }
    }
  }
</style>
